const convert = require('color-convert');

var BuYlRd = {
  3: ["#91bfdb","#ffffbf","#fc8d59"],
  4: ["#2c7bb6","#abd9e9","#fdae61","#d7191c"],
  5: ["#2c7bb6","#abd9e9","#ffffbf","#fdae61","#d7191c"],
  6: ["#4575b4","#91bfdb","#e0f3f8","#fee090","#fc8d59","#d73027"],
  7: ["#4575b4","#91bfdb","#e0f3f8","#ffffbf","#fee090","#fc8d59","#d73027"],
  8: ["#4575b4","#74add1","#abd9e9","#e0f3f8","#fee090","#fdae61","#f46d43","#d73027"],
  9: ["#4575b4","#74add1","#abd9e9","#e0f3f8","#ffffbf","#fee090","#fdae61","#f46d43","#d73027"],
  10: ["#313695","#4575b4","#74add1","#abd9e9","#e0f3f8","#fee090","#fdae61","#f46d43","#d73027","#a50026"],
  11: ["#313695","#4575b4","#74add1","#abd9e9","#e0f3f8","#ffffbf","#fee090","#fdae61","#f46d43","#d73027","#a50026"]
}

var pdk_pal = ["#2c7bb6","#abd9e9","#fdae61","#d7191c"]

// var RdPuBu = {
//   3: ["#710060","#5A0092","#91bfdb"],
//   4: ["#710060","#650079","#5A0092","#2c7bb6"],
//   5: ["#710060","#650079","#5A0092","#451B93","#2c7bb6"],
//   6: ["#710060","#650079","#5A0092","#4C1293","#3E2494","#4575b4"],
//   7: ["#710060","#690070","#610081","#5A0092","#4C1293","#3E2494","#4575b4"],
//   8: ["#710060","#690070","#610081","#5A0092","#4F0D92","#451B93","#3B2894","#4575b4"],
//   9: ["#710060","#6B006C","#650079","5F0085","#5A0092","#4F0D92","#451B93","#3B2894","#4575b4"],
//   10: ["#710060","#6B006C","#650079","#5F0085","#5A0092","#510A92","#491593","#412093","#392B94","#313695"],
//   11: ["#710060","#510A92","#491593","#412093","#392B94","#5A0092","#510A92","#491593","#412093","#392B94","#313695"]
// }

var humidity_pal = ['#FF6D9C', '#FF8189', '#FF9279', '#FFA270', '#FFAF6D', '#F7BC73', '#EEC77F', '#E6D090', '#E0D9A3', '#DCE0B7', '#DDE6CB',
'#C3DBB9', '#A5D1AD', '#82C7A6', '#58BCA6', '#17B0A8', '#00A2AE', '#0093B3', '#0081B7', '#306BB9', '#5F4EB6']

var prec_pal = ['#DDE6CB', '#C3DBB9', '#A5D1AD', '#82C7A6', '#58BCA6', '#17B0A8', '#00A2AE', '#0093B3', '#0081B7', '#306BB9', '#5F4EB6']

var wind_pal = ['#525252', '#555E6A', '#446E7A', '#1A807E', '#009072', '#3A9C57', '#77A41B', '#AFA600', '#E4A200', '#FF9962', '#FF8BB7']

var pressure_pal = ['#26185F', '#15305F', '#0A4161', '#115065', '#245E6A', '#396B6F', '#4E7875', '#64857D', '#7A9287', '#8F9E94', '#A3ABA3',
'#B6B8B4', '#C6C6C6', '#B7B8B2', '#AAAA9D', '#9F9B88', '#968B74', '#8E7C61', '#876C4F', '#805C3F', '#794B31', '#723A25', '#6B271E',
'#640D1A', '#5F001B']

var temp_pal = ['#680000', '#700020', '#780033', '#7E0043', '#840051', '#88005E', '#8C006B', '#8F0076',
'#911081', '#93278C', '#943895', '#94469E', '#9453A7', '#945FAF', '#936BB6', '#9376BD', '#9381C4', '#938CCA',
'#9397D0', '#95A1D5', '#97ABDA', '#9AB5DF', '#9EBEE4', '#A3C8E8', '#AAD1EC', '#B1DAF1', '#B9E3F5', '#C2ECFA',
'#CCF5FF', '#D7FDFF', '#E2FFFF', '#D7FFFF', '#CCFCF9', '#C1F7F0', '#B7F2E6', '#AEEDDB', '#A6E7D0', '#A0E2C4',
'#9ADCB8', '#96D6AB', '#94D09E', '#93C991', '#93C383', '#94BC75', '#95B566', '#98AD57', '#9AA648', '#9D9E38',
'#9F9626', '#A18E0F', '#A38500', '#A57D00', '#A67400', '#A76B00', '#A76100', '#A75800', '#A74D17', '#A64226',
'#A53632', '#A3273C', '#A21146']

var cloud_pal = ["#0571b0", "#3d93c3", "#76b4d5", "#a6cfe3", "#cfe3ed",
"#f7f7f7", "#e7e7e7", "#d6d6d6", "#b6b6b6", "#858585", "#545454"]

var norm_pal = ['#003560', '#005082', '#006DA9', '#0084B9', '#249AC5', '#6FAFD1', '#9BC4DD', '#BDD6E7', '#D9E6EF', '#EEF2F6',
'#F9F9F9', '#F5E9E7', '#F1D2CE', '#EDB9B2', '#E79E93', '#DF8271', '#D5644A', '#C74300', '#AB2C00', '#851F00', '#611300']

var norm_inv_pal = ['#611300', '#851F00', '#AB2C00', '#C74300', '#D5644A', '#DF8271', '#E79E93', '#EDB9B2', '#F1D2CE',
'#F5E9E7', '#F9F9F9', '#EEF2F6', '#D9E6EF', '#BDD6E7', '#9BC4DD', '#6FAFD1', '#249AC5', '#0084B9', '#006DA9', '#005082', '#003560']

function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}

// var out82 = false;
// var out86 = false;

function get_color(value, min, max, step, palette, reverse = 0, nan_color = '#FFFFFF') {
  var nbins = Math.ceil((max - min)/step);
  var bin = Math.floor((value - min)/step);
  if (value <= min) {
    bin = 0;
  } else if (value >= max) {
    bin = nbins - 1;
  }

  if (isNaN(bin)){
    return nan_color
  }

  if (nbins <= 11) {
    if (reverse == 1) {
      return palette[nbins].reverse()[bin];
    } else {
      return palette[nbins][bin];
    }
  } else {
    var k = Math.floor(nbins / 9) + 1;

    var nbins_new = Math.ceil(nbins/k) + 1;
    var bin_new = Math.floor((value - min) * nbins_new / (max - min));

    bin_new = bin_new < 0 ? 0 : bin_new;
    bin_new = bin_new >= nbins_new ? nbins_new - 1 : bin_new;

    var bin_new2 = (bin_new == nbins_new - 1) ? bin_new : bin_new + 1;

    var colors = palette[nbins_new];
    if (reverse == 1) colors = colors.reverse();

    var hsl1 = convert.hex.rgb(colors[bin_new]);
    var hsl2 = convert.hex.rgb(colors[bin_new2]);

    var w = 1 - (bin % k) / k // weighting coefficient

    var hsl = [
      Math.floor(w * hsl1[0] + (1-w) * hsl2[0]),
      Math.floor(w * hsl1[1] + (1-w) * hsl2[1]),
      Math.floor(w * hsl1[2] + (1-w) * hsl2[2]),
    ];

    return '#' + convert.rgb.hex(hsl);

  }
}

function get_color_new(value, min, max, step, palette) {
  // var npos = Math.ceil((max - min)/step) + 1;

  if (value < min) {
    value = min
  } else if (value > max) {
    value = max
  }
  
  step = (max - min) / palette.length

  var pos1 = Math.floor((value - min)/step);
  var pos2 = Math.ceil((value - min)/step);
  
  if (pos1 < 0) {
    pos1 = 0
  } else if (pos1 >= palette.length) {
    pos1 = palette.length - 1
  }	 

  if (pos2 < 0) {
    pos2 = 0
  } else if (pos2 >= palette.length) {
    pos2 = palette.length - 1
  }	 

  var hsl1 = convert.hex.rgb(palette[pos1]);
  var hsl2 = convert.hex.rgb(palette[pos2]);

  var w = (value - (pos1 * step + min)) / step // weighting coefficient

  var hsl = [
    Math.floor((1-w) * hsl1[0] + w * hsl2[0]),
    Math.floor((1-w) * hsl1[1] + w * hsl2[1]),
    Math.floor((1-w) * hsl1[2] + w * hsl2[2]),
  ];

  return '#' + convert.rgb.hex(hsl);
}

function select_unicolor(z, min, max, step, variable, pal = BuYlRd) {
    return(get_color(z, min, max, step, pal))
}

function select_color(z, min, max, step, variable = 'temperature') {
  switch(variable) {
    case 'humidity':
      return(get_color_new(z, min, max, step, humidity_pal))
    case 'wind':
      return(get_color_new(z, min, max, step, wind_pal))
    case 'pressure':
      return(get_color_new(z, min, max, step, pressure_pal))
    case 'cloud':
      return(get_color_new(z, min, max, step, cloud_pal))
    case 'prec':
      if (z < 0.001) return '#FFFFFF'
      else return(get_color_new(z, min, max, step, prec_pal))
    case 'pdk':
      return(get_color_new(z, min, max, step, pdk_pal))
    default:
      return(get_color_new(z, min, max, step, temp_pal))
  }
}

function select_color_norm(z, min, max, step, variable = 'temperature') {
  // console.log({z, min, max, step, variable});
  if (variable == 'humidity' || variable == 'prec') {
    return(get_color_new(z, min, max, step, norm_inv_pal))
  } else {
    return(get_color_new(z, min, max, step, norm_pal))
  }
}

function get_colors(palette, min, max, step) {
  var val = min + step/2;
  var arr = [];
  while (val < max){
    arr.push(get_color(palette, val, min, max, step))
    val += step;
  }
  return arr;
}

function get_values(from, to, by){
  var arr = [];
  var val = from;
  while (to - val >= - 0.5 * by) {
    arr.push(round(val,1));
    val += by;
  }
  return arr;
}

function get_text_color(z) {
  if (z > 0) {
    return '#000';
  } else {
    return '#FFFFFF';
  }
}

module.exports = {
  get_color, get_colors, get_values, round, get_text_color, select_color, select_unicolor, select_color_norm
}
